import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { useBreadcrumbStore } from '@/store/breadcrumbStore';

function toTitle(segment: string): string {
  return segment
    .replace(/-/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

/** Location-aware breadcrumb trail derived from the current route path. */
export default function AppBreadcrumbs() {
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);
  const labels = useBreadcrumbStore((s) => s.labels);
  // Prefer a registered entity name (e.g. a KPI/project id → its name) over the raw segment.
  const labelFor = (segment: string) => labels[segment] ?? toTitle(segment);

  return (
    <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
      <Link
        component={RouterLink}
        to="/"
        underline="hover"
        color="inherit"
        sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
      >
        <HomeOutlinedIcon fontSize="small" />
        Home
      </Link>
      {segments.map((segment, index) => {
        const to = '/' + segments.slice(0, index + 1).join('/');
        const isLast = index === segments.length - 1;
        return isLast ? (
          <Typography key={to} color="text.primary" sx={{ fontWeight: 600 }}>
            {labelFor(segment)}
          </Typography>
        ) : (
          <Link key={to} component={RouterLink} to={to} underline="hover" color="inherit">
            {labelFor(segment)}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
}
